import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { MOCK_BRIGHTEDGE_ERROR_SERVLET } from "utils-lib/mocks"
import { urls } from "utils-lib/builds"
import {
  GET_BRIGHTEDGE_MESSAGE_SERVLET_PENDING,
  GET_BRIGHTEDGE_MESSAGE_SERVLET_FAILED,
  GET_BRIGHTEDGE_MESSAGE_SERVLET_FULFILLED,
} from "constants-lib/actionTypes"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export const pendingAC = () => ({
  type: GET_BRIGHTEDGE_MESSAGE_SERVLET_PENDING,
})

export const failedAC = (data) => ({
  type: GET_BRIGHTEDGE_MESSAGE_SERVLET_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: GET_BRIGHTEDGE_MESSAGE_SERVLET_FULFILLED,
  payload: data,
})

export const getServletBrightEdge = () => (dispatch) => {
  const href = ssrWindow.location.href
  const currentPage = href || ""
  const api = `BRIGHTEDGE`
  const template = URITemplate(urls.url[api])
  const preURL = template.expand({
    currentPage,
  })
  const decodedUrl = decodeURIComponent(preURL)
  const url = MOCK_BRIGHTEDGE_ERROR_SERVLET
    ? `${ssrWindow.origin}/mock/brightEdge.json`
    : decodedUrl

  const config = {
    url,
    method: `get`,
  }

  dispatch(pendingAC(currentPage))
  // eslint-disable-next-line consistent-return
  return axios(config)
    .then((response) => {
      dispatch(fulfilledAC(response.data))
      return response.data
    })
    .catch((error) => {
      dispatch(failedAC(error?.response?.status))
      return error
    })
}
